import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { putDiscovery } from 'services/endpoints/settings/account/privacyAndPolicy'
import { useUserProfile } from 'store'

export const Discovery = () => {
    const userData = useUserProfile()
    const { t } = useTranslation()
    const queryClient = useQueryClient()
    const [discoveryActive, setDiscoveryActive] = useState<boolean>(
        !!userData?.disabled_discovery
    )

    const updateDiscovery = useMutation(
        async () => await putDiscovery(!discoveryActive),
        {
            onError: err => {
                console.error(err)
                addToast('error', t('error:errorSomethingWentWrong'))
            },
            onSuccess: () => {
                queryClient.invalidateQueries('user-profile')
            }
        }
    )

    return (
        <>
            <WithHeaderSection
                headerSection={
                    <LayoutHeader
                        type='basic'
                        section={t('privacySecurity')}
                        title={t('discovery')}
                    />
                }
            >
                <ActionCard
                    hasSwitch
                    toggleFn={() => {
                        setDiscoveryActive(!discoveryActive)
                        updateDiscovery.mutate()
                    }}
                    toggleActive={discoveryActive}
                    text={t('suggestionsOptOut')}
                    subtext={
                        <span style={{ color: '#778797' }}>
                            {t(
                                'controlWhetherYourProfileCanBeSuggestedToOurUsers'
                            )}
                        </span>
                    }
                    description={
                        <span style={{ color: '#B0B0B0' }}>
                            {t('note')}:
                            <br />
                            {t('thisFeatureDoesRespectGeoBlocking')}
                        </span>
                    }
                />
            </WithHeaderSection>
        </>
    )
}
